import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from "@chakra-ui/react"

const FormField = ({ label, helperText, errorMessage, children, ...props }) => (
  <FormControl {...props}>
    {!!label && (
      <FormLabel fontSize="sm" fontWeight="bold" color="gray.700">
        {label}
      </FormLabel>
    )}
    {children}
    {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
    {!!errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
  </FormControl>
)

export default FormField
